module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/19mill-active-943370cd4708718b22889af9d75ca0b1.png";